import React from 'react';

import { HEIGHT_ITEM } from '../../../const';
import GantItemControlEdit from '../../gantItemControlEdit';
import { ProjectTreeRecordType } from '../projectsTreeTypes';
import { ProjectsTreeCell } from './projectsTreeCell';

export interface ProjectCellProps {
    project: ProjectTreeRecordType;
}

export const ProjectsTreeProjectCell: React.FC<ProjectCellProps> = ({ project }) => {
    return (
        <ProjectsTreeCell record={project} paddingRight={5} hasCollapseControl>
            <div
                style={{
                    flex: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: 14,
                    fontWeight: 700,
                }}
            >
                {project.item.name}
            </div>

            <div
                style={{
                    width: 20,
                    paddingTop: 7,
                    paddingRight: 3,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxSizing: 'content-box',
                }}
            >
                <svg
                    width={20}
                    height={HEIGHT_ITEM}
                    style={{
                        position: 'relative',
                    }}
                >
                    <GantItemControlEdit projectId={project.item.projectId!} onClickToStart={() => {}} />
                </svg>
            </div>
        </ProjectsTreeCell>
    );
};
